import { concat, from, of, } from "rxjs";
import { concatMap, ignoreElements, publish, takeUntil } from "rxjs/operators";
export function switchTap(next) {
    return (source) => source.pipe(publish((published) => published.pipe(concatMap((value) => concat(from(next(value)).pipe(ignoreElements(), takeUntil(published)), of(value))))));
}
//# sourceMappingURL=switchTap.js.map